export const ADD_SERVICE = "ADD_SERVICE";
export const REMOVE_SERVICE = "REMOVE_SERVICE";
export const SET_SERVICES = "SET_SERVICES";

export const INITIALIZE_BASKET = "INITIALIZE_BASKET";

export const MODIFY_BASKET = "MODIFY_BASKET";
export const MODIFY_AMOUNT = "MODIFY_AMOUNT";
export const MODIFY_PRICE = "MODIFY_PRICE";
